module.exports = __webpack_public_path__ + "img/logo-white.04266204.png";